import { watch } from "@vue/composition-api";
import { assign } from "xstate";
import { isLocal } from "@/utils/constants";
import get from "just-safe-get";

export const watchState = (state, label = "") => {
  return watch(state, (newState, oldState) => {
    // Watch for state changes in dev...
    if (isLocal) {
      console.group(label ? `${label} Service` : "State Service");
      console.log(
        "%c State:",
        "color: #bada55",
        JSON.stringify(newState.value, null, 2)
      );

      // Log out the context and iterate over it's properties to format it nicely...
      console.group("Context");
      for (let [key, value] of Object.entries(newState.context)) {
        if (value && typeof value === "object") {
          console.groupCollapsed(`${key} (${typeof value})`);
          for (let [k, v] of Object.entries(value)) {
            console.log(k, v);
          }
          console.groupEnd();
        } else {
          console.log(`${key}: ${value} (${typeof value})`);
        }
      }
      console.groupEnd();
      console.groupEnd();
    }
  });
};

export const mapGraphQlErrorResponse = (errors = []) =>
  errors.map((error) => error.message);

// Helper method to get the graphQl response data...
export const getGraphQlData = (event, keys) => {
  return get(event, `data.data.${keys}`);
};

// Actions
// Default actions we use in most state machines...
export const helperActions = {
  assignErrors: assign({
    errors: (context, event) => {
      return event.data?.graphQLErrors
        ? mapGraphQlErrorResponse(event.data?.graphQLErrors)
        : [event.data];
    },
  }),
  // trackErrors: (context, event) =>
  //   mapGraphQlErrorResponse(event?.data?.errors).forEach((error) =>
  //     logger.error(error)
  //   ),
};

// Services
// Used to test graphQl responses from AppSync...
// export const mockGraphQlResponse = async ({ request, response, error }) => {
//   if (error) {
//     return Promise.reject(error);
//   }

//   // Mock response
//   return {
//     data: {
//       [request]: response,
//     },
//   };
// };
